import React, { createContext } from 'react';
import { StockOptionOptionsDTO } from '../api/useStockOptionsQuery';

interface Context {
  options: StockOptionOptionsDTO;
}

export const StockOptionsContext = createContext<Context | undefined>(undefined);

interface Props {
  value: Context;
  children: React.ReactNode;
}

export const StockOptionsProvider = ({ children, value }: Props) => (
  <StockOptionsContext.Provider value={value}>{children}</StockOptionsContext.Provider>
);
